// extracted by mini-css-extract-plugin
var _1 = "SubmenuIconStyle-module__icon___HRk3r";
var _2 = "SubmenuIconStyle-module__submenu-icon___c_zWW";
var _3 = "SubmenuIconStyle-module__submenu-icon___c_zWW";
var _4 = "SubmenuIconStyle-module__svg-icon___ZDmZo";
var _5 = "SubmenuIconStyle-module__svg-icon___ZDmZo";
export { _1 as "icon", _2 as "submenu-icon", _3 as "submenuIcon", _4 as "svg-icon", _5 as "svgIcon" }
